import { Alert, Grid } from '@mui/material';
import React from 'react';
import { lang } from 'src/utils';

import { ErrorInfo } from './ErrorInfo';

interface Props {
  isGcfPlayer?: boolean;
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class GCFErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      errorMessage: error.message.includes('http') ? '' : error.message,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.isGcfPlayer) {
        return (
          <ErrorInfo
            title={lang.errors.notSupported}
            info={lang.errors.tryAgain}
          />
        );
      }

      return (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          height="100%">
          <Alert severity="error">
            {!!this.state.errorMessage
              ? this.state.errorMessage
              : lang.errors.renderError}
          </Alert>
        </Grid>
      );
    }

    return this.props.children;
  }
}
